<script>
  export default {
    name: "AppMoi",
  }
</script>

<template>
  <section id="moi">
    <div class="wire-ctnB">
      <div class="wire1"></div>
      <div class="wire2"></div>
      <div class="wire3"></div>
    </div>
    <div class="moi-ctn">
      <div class="border-top1"></div>
      <div class="border-top2"></div>
      <div class="border-top3"></div>
      <div class="border-top4"></div>
      <div class="border-top5"></div>
      <div class="border-top6"></div>
      <div class="border-top7"></div>
      <div class="light"></div>
      <div class="description">
        <div class="ml">
          <h2>À propos de moi</h2>
          <h4>Numa VERPILLON</h4>
          <h4>21 ans</h4>
          <h4>Auto-entrepreneur</h4>
          <div class="about-btn"><router-link to="/about">En savoir plus</router-link></div>
        </div>
        <img class="numa" src="@/assets/images/numa2.jpg">
      </div>
    </div>
  </section>
</template>

<style>

  #moi{
    position: relative;
  }

  .moi-ctn{
    position: relative;
    margin: 15vh 20vw 0 20vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ml{
    padding-left: 4.5vw;
  }

  .wire-ctnB {
    position: absolute;
    top: 0;
    right: 0;
    width: 50vw;
    height: 100vh;
    z-index: 0;
  }

  .wire-ctnB .wire1{
    position: absolute;
    opacity: 0.8;
    top: 15%;
    right: 0;
    width: 22%;
    height: 20%;
    border-top: solid #22527a 0.5vw;
    border-left: solid #22527a 0.5vw;
  }

  .wire-ctnB .wire2{
    position: absolute;
    opacity: 0.8;
    top: 20%;
    right: 0;
    width: 17%;
    height: 15%;
    border-top: solid #22527a 0.5vw;
    border-left: solid #22527a 0.5vw;
  }

  .wire-ctnB .wire3{
    position: absolute;
    opacity: 0.8;
    top: 35%;
    right: 15%;
    width: 10%;
    height: 2.5%;
    background-color: #22527a;
  }

  .light{
    position: absolute;
    background-color: #ffffa8;
    left: 50%;
    top: -3px;
    width: 2.8%;
    height: 6px;
    transform: translateX(-50%);
    z-index: 1;

    box-shadow:
        0 0 15px rgba(255, 255, 168, 0.8),
        0 0 30px rgba(255, 255, 168, 0.6),
        0 0 45px rgba(255, 255, 168, 0.4),
        0 0 60px rgba(255, 255, 168, 0.2);

    animation: oscillation 3s ease-in-out infinite;
  }

  @keyframes oscillation {
    0% {
      box-shadow:
          0 0 15px rgba(255, 255, 168, 0.8),
          0 0 30px rgba(255, 255, 168, 0.6),
          0 0 45px rgba(255, 255, 168, 0.4),
          0 0 60px rgba(255, 255, 168, 0.2);
    }
    50% {
      box-shadow:
          0 0 15px rgba(255, 255, 168, 1),
          0 0 30px rgba(255, 255, 168, 0.9),
          0 0 15px rgba(255, 255, 168, 0.8),
          0 0 60px rgba(255, 255, 168, 0.7);
    }
    100% {
      box-shadow:
          0 0 15px rgba(255, 255, 168, 0.8),
          0 0 30px rgba(255, 255, 168, 0.6),
          0 0 45px rgba(255, 255, 168, 0.4),
          0 0 60px rgba(255, 255, 168, 0.2);
    }
  }

  .border-top1{
    position: absolute;
    background-color: #72cdff;
    left: -0.5%;
    top: -4px;
    width: 47.5%;
    height: 8px;
    z-index: 1;
  }

  .border-top2{
    position: absolute;
    background-color: #72cdff;
    right: -0.5%;
    top: -4px;
    width: 47.5%;
    height: 8px;
    z-index: 1;
  }

  .border-top3{
    position: absolute;
    background-color: #007cbf;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    width: 99.7%;
    height: 12px;
    z-index: 0;
  }

  .border-top4{
    position: absolute;
    background-color: #72cdff;
    left: 50%;
    top: 8px;
    transform: translateX(-50%);
    width: 8%;
    height: 4px;
    z-index: 1;
  }

  .border-top5{
    position: absolute;
    background-color: #72cdff;
    left: 0;
    top: 12px;
    width: 100%;
    height: 2px;
    z-index: 1;
  }

  .border-top6{
    position: absolute;
    background-color: #72cdff;
    left: 46.1%;
    top: 4px;
    width: 0.9%;
    height: 4px;
    z-index: 1;
  }
  .border-top7{
    position: absolute;
    background-color: #72cdff;
    right: 46%;
    top: 4px;
    width: 1%;
    height: 4px;
    z-index: 1;
  }

  .description{
    width: 60vw;
    padding: 4vh 2vw 2vh 2vw;
    border: solid 2px;
    border-color: #37b6fe;
    border-top: none;
    background-color: #1d2c6a;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 7vw;
  }

  .description h2{
    margin: 2vh 0 3vh 0;
    font-size: 6vh;
  }

  .description h4{
    margin: 1vh 0;
    font-size: 4.6vh;
  }

  .description a{
    font-size: 4vh;
    text-decoration: none;
    color: white;
    background-color: #2a4683;
    padding: 8px 12px;
    border-radius: 8px;
  }

  .about-btn{
    margin-top: 3.2vh;
    margin-bottom: 1vh;
  }

  .numa{
    width: 20vw;
    height: 20vw;
  }

  /* RESPONSIVE */

  @media (max-width: 768px) {
    .moi-ctn{
      margin: 15vh 16vw 0 16vw;
    }
    .description{
      width : 64vw;
    }
    .description h2{
      font-size: 5vh;
    }
    .description h4{
      font-size: 4vh;
    }
  }

  @media (max-width: 768px) {
    .moi-ctn{
      margin: 12vh 8vw 0 8vw;
    }
    .description{
      width : 80vw;
    }
    .ml{
      padding-left: 0;
    }
    .numa{
      display: none;
    }
  }

</style>